import _ from "lodash";
import { Table } from "../Table/Table";
import { useMemo, useState } from "react";
import { Button, Icon, List, Popup } from "semantic-ui-react";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import { getContactsInfo } from "services/common";

export const MediaAgencyTable = ({ items, users, handleUpdate, handleDelete, t }) => {
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    text: "",
    headerText: "",
    icon: "",
  });
  const [confirmationModalOnSuccess, setConfimationModalOnSuccess] = useState(() => {
    return;
  });
  const [confirmationModalDataForOnSuccess, setConfimationModalDataForOnSuccess] = useState({});

  /* Filter and Cell functions use the function-syntax here to go around an eslint warning:
    "Component definition is missing display name. eslint(react/display-name)"
  */
  const columns = useMemo(
    () => [
      {
        Header: t("name"),
        accessor: "name",
      },
      {
        Header: t("emails"),
        accessor: "email",
        width: 210,
      },
      {
        Header: t("contacts"),
        accessor: (originalRow) => {
          const contactsInfo = getContactsInfo(originalRow["contacts"], users);
          return _.join(contactsInfo, " ");
        },
        width: 300,
        Cell: function contactsCell({ row }) {
          const contactsInfo = getContactsInfo(row.original.contacts, users);
          return (
            <List divided>
              {_.map(contactsInfo, (info, i) => (
                <List.Item key={i}>{info}</List.Item>
              ))}
            </List>
          );
        },
      },
      {
        id: "updateDeleteRow",
        maxWidth: 10,
        Cell: function updateDeleteRow({ row }) {
          return (
            <>
              <Popup
                content={t("media_agency_update")}
                trigger={
                  <Button basic icon size="mini" onClick={() => handleUpdate(row.original)}>
                    <Icon name="edit outline" />
                  </Button>
                }
              />
              <Popup
                content={t("media_agency_delete")}
                trigger={
                  <Button
                    basic
                    icon
                    size="mini"
                    onClick={() => {
                      setConfirmationModalData({
                        text: t("media_agency_delete_modal_text"),
                        headerText: t("media_agency_delete"),
                        icon: "delete",
                      });
                      setConfimationModalOnSuccess(() => handleDelete);
                      setConfimationModalDataForOnSuccess(row.original);
                      setConfirmationModalOpen(true);
                    }}
                  >
                    <Icon name="delete" />
                  </Button>
                }
              />
            </>
          );
        },
      },
    ],
    [handleUpdate, handleDelete, getContactsInfo]
  );

  return (
    <>
      <Table columns={columns} data={items} useTableGlobalFilter={true} t={t} />
      <ConfirmationModal
        data={confirmationModalData}
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        onSuccess={confirmationModalOnSuccess}
        dataForOnSuccess={confirmationModalDataForOnSuccess}
      />
    </>
  );
};
